module.exports = __webpack_public_path__ + "static/img/store3.fc83ec4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/store3.png
// module id = GX9r
// module chunks = 1